//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import { convertAndFormatTimeToLocal } from "@/assets/js/appFunc";
import FroalaComponent from "@/components/UserInterfaces/components/froala/FroalaComponent.vue";
import TabComponents from "../mixins/tab-components";

export default {
    components: {
        AQCard,
        AQInput,
        AQButton,
        AQMenu,
        AQDialog,
        AQBadge,
        AQModal,
        FroalaComponent
    },
    mixins: [TabComponents],
    props: {
        instanceID: {
            type: String,
            default: ""
        },
        systemStatus: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            APP_DATE_DOT_FORMAT,
            richTextExist: false,
            richTextList: null,
            showLoadMoreDocBtn: false,
            openDialog: false,
            showRichTextDetails: false,
            processInstanceName: "",
            modifiedOn: "",
            modifiedBy: "",
            variablePath: "",
            content: "",
            idRichText: "",
            richTextPayload: {
                page: 0,
                size: 5,
                processInstanceId: this.instanceID
            },
            actionMenu: [],
            optionsMenu: [
                {
                    value: "delete",
                    label: this.$t("generic.delete"),
                    itemDisabled: this.systemStatus === "RUNNING" || this.systemStatus === "FAILED"
                }
            ]
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        headerActionsModel() {
            return [{ label: this.$t("generic.delete"),
                itemDisabled: this.systemStatus === "RUNNING" || this.systemStatus === "FAILED" }];
        }
    },
    watch: {
        systemStatus: {
            handler(newValue) {
                if (newValue !== "RUNNING" || newValue !== "FAILED") {
                    this.isDisabledMenu();
                }
            }
        }
    },
    beforeDestroy() {
    },
    mounted() {
        this.richTextListExists();
    },

    methods: {
        ...mapActions("admin", ["getRichTextList", "deleteRichText", "getRichTextDetails"]),
        convertAndFormatTimeToLocal,

        richTextListExists(loadMore) {
            if (!loadMore) {
                this.richTextPayload.page = 0;
            }
            this.getRichTextList(this.richTextPayload).then(data => {
                if (data.data && data.data.entries && data.data.entries.length) {
                    this.richTextExist = true;
                    this.richTextList = loadMore ? this.richTextList.concat(data.data.entries) : data.data.entries;
                    this.showLoadMoreDocBtn = this.richTextPayload.size * (this.richTextPayload.page + 1) < data.data.totalElements;
                } else {
                    this.richTextExist = false;
                }
            });
        },
        loadMoreItems() {
            ++this.richTextPayload.page;
            this.richTextListExists(true);
        },
        optionSelected(item) {
            if (this.actionMenu[0].value === "delete") {
                this.payload = {
                    id: item.id
                };
                this.openDialog = true;
            }
            this.actionMenu = [];
        },
        cancelAction() {
            this.openDialog = false;
        },
        okAction() {
            this.deleteRichText(this.payload.id).then(() => {
                for (let i = 0; i < this.richTextList.length; i++) {
                    if (this.richTextList[i].id === this.payload.id) {
                        this.richTextListExists();
                        if (this.showRichTextDetails) {
                            this.showRichTextDetails = false;
                        }
                        break;
                    }
                }
                this.showNotify();
            });
        },
        showNotify() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("admin.processInspector.deleteRichTextConfirmation"),
                timeout: 500
            });
        },
        openRichTextDetailsModal(item) {
            this.payload = {
                id: item.id
            };
            this.showRichTextDetails = true;
            this.getRichTextDetails(this.payload.id).then((data) => {
                this.processInstanceName = data.data.processInstanceName;
                this.modifiedOn = data.data.modifiedOn;
                this.modifiedBy = data.data.modifiedBy;
                this.variablePath = data.data.variablePath;
                this.content = data.data.content;
                this.idRichText = data.data.id;
            });
        },
        actionsDialog($event) {
            if ($event === "close") {
                this.showRichTextDetails = false;
            } else if ($event === this.$t("generic.delete")) {
                this.openDialog = true;
            }
        },
        isDisabledMenu() {
            this.optionsMenu[0].itemDisabled = false;
        }
    }

};

